import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import './MainLayout.css';
import { API_BASE_URL, getPublicIpv4 } from '../global';

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    const registerSessionAccess = async () => {
      const userId = localStorage.getItem('userId');
      if (!userId) return;
      try {
        const ip = await getPublicIpv4();
        fetch(`${API_BASE_URL}/auth.php?action=log_access`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: userId, ip })
        }).catch(() => {});
      } catch (err) {
        // Silencioso
      }
    };
    registerSessionAccess();
  }, []);

  return (
    <div className="app-container">
      <Sidebar isOpen={sidebarOpen} />
      <div className="main-content">
        <Topbar toggleSidebar={toggleSidebar} />
        <div className="page-wrapper animate-fade-in">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
